import ReactGA from 'react-ga4';

// Google Analytics Konfiguration - nur für wichtige Seitenaufrufe
const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || 'G-XXXXXXXXXX';

// Prüfung ob Analytics durch Cookie Consent freigegeben wurde
const isAnalyticsEnabled = () => {
  return window.GA_ENABLED === true;
};

// Prüfung ob ReactGA bereits initialisiert wurde
let isInitialized = false;

export const initGA = () => {
  if (TRACKING_ID && TRACKING_ID !== 'G-XXXXXXXXXX') {
    // Nur initialisieren wenn Cookie Consent gegeben wurde und noch nicht initialisiert
    if (isAnalyticsEnabled() && !isInitialized) {
      ReactGA.initialize(TRACKING_ID, {
        debug: process.env.NODE_ENV === 'development',
        testMode: process.env.NODE_ENV === 'test',
        gtagOptions: {
          anonymize_ip: true,
          allow_ad_personalization_signals: false,
          allow_google_signals: false,
          restricted_data_processing: true
        }
      });
      isInitialized = true;
      
      // Send a test event to verify it's working
      ReactGA.send({ hitType: 'pageview', page: '/test-init' });
    }
  } else {
    console.warn('Google Analytics tracking ID not found. Please set REACT_APP_GA_TRACKING_ID in your environment variables.');
  }
};

// Reset initialization status (für Testing)
export const resetGA = () => {
  isInitialized = false;
};

// Seitenaufrufe tracken - nur für bestimmte Seiten und nur mit Consent
export const trackPageView = (path, title = null) => {
  if (TRACKING_ID && TRACKING_ID !== 'G-XXXXXXXXXX' && isAnalyticsEnabled()) {
    if (!isInitialized) {
      initGA();
    }
    
    if (isInitialized) {
      const trackingData = { hitType: 'pageview', page: path };
      
      // Add title if provided
      if (title) {
        trackingData.title = title;
      }
      
      ReactGA.send(trackingData);
    }
  }
};

// Thread-View mit Titel tracken (speziell für Thread-Seiten)
export const trackThreadView = (threadId, threadTitle, page = 1) => {
  if (TRACKING_ID && TRACKING_ID !== 'G-XXXXXXXXXX' && isAnalyticsEnabled()) {
    if (!isInitialized) {
      initGA();
    }
    
    if (isInitialized) {
      const path = `/forum/thread/${threadId}${page > 1 ? `?page=${page}` : ''}`;
      const title = threadTitle ? `${threadTitle} - Forum Thread` : `Thread ${threadId}`;
      
      ReactGA.send({ 
        hitType: 'pageview', 
        page: path,
        title: title
      });
      
      // Additional event for thread analytics
      ReactGA.event({
        action: 'View Thread',
        category: 'Thread Activity',
        label: threadTitle || `Thread ${threadId}`,
        value: page
      });
    }
  }
};

// Forum-View mit Titel tracken (speziell für Forum-Seiten)
export const trackForumView = (forumId, forumName, page = 1) => {
  if (TRACKING_ID && TRACKING_ID !== 'G-XXXXXXXXXX' && isAnalyticsEnabled()) {
    if (!isInitialized) {
      initGA();
    }
    
    if (isInitialized) {
      const path = `/forum/forum/${forumId}${page > 1 ? `?page=${page}` : ''}`;
      const title = forumName ? `${forumName} - Forum` : `Forum ${forumId}`;
      
      ReactGA.send({ 
        hitType: 'pageview', 
        page: path,
        title: title
      });
      
      // Additional event for forum analytics
      ReactGA.event({
        action: 'View Forum',
        category: 'Forum Activity',
        label: forumName || `Forum ${forumId}`,
        value: page
      });
    }
  }
};

// Thread-View Event (wenn ein Thread aufgerufen wird)
export const trackThreadEvent = (action, threadId = '') => {
  if (TRACKING_ID && TRACKING_ID !== 'G-XXXXXXXXXX' && isAnalyticsEnabled()) {
    ReactGA.event({
      action,
      category: 'Thread Activity',
      label: `Thread: ${threadId}`,
    });
  }
};

// Forum-View Event (wenn ein Forum aufgerufen wird)
export const trackForumEvent = (action, forumId = '') => {
  if (TRACKING_ID && TRACKING_ID !== 'G-XXXXXXXXXX' && isAnalyticsEnabled()) {
    ReactGA.event({
      action,
      category: 'Forum Activity', 
      label: `Forum: ${forumId}`,
    });
  }
};

export default {
  initGA,
  trackPageView,
  trackThreadView,
  trackForumView,
  trackThreadEvent,
  trackForumEvent,
};
